// extracted by mini-css-extract-plugin
module.exports = {"articleRead":"style_articleRead__4N13k","link":"style_link__Fx_f8","articleLeft":"style_articleLeft__q8jJu","articleRight":"style_articleRight__DZtJe"};